import React from 'react';
import {
  ArrowDownLeft, ArrowUpRight, DollarSign,
} from 'lucide-react';

/**
 * Icon returned for a given wallet-transaction type.
 * Kept local to the wallet feature to avoid growing the shared UI.
 */
export function getTransactionIcon(type) {
  switch (type) {
    case 'deposit':
    case 'earning':
    case 'payroll':
    case 'payment_received':
    case 'reward':
    case 'bonus':
    case 'refund':
      return <ArrowDownLeft className="w-4 h-4 text-green-600" />;
    case 'withdrawal':
    case 'transfer':
    case 'escrow_hold':
    case 'marketplace_purchase':
    case 'commission_reversal':
    case 'p2p_sent':
    case 'chargeback':
    case 'fee':
      return <ArrowUpRight className="w-4 h-4 text-red-600" />;
    default:
      return <DollarSign className="w-4 h-4 text-gray-600" />;
  }
}

/** Rounded-pill status badge for a transaction row. */
export function getStatusBadge(status) {
  const classes = {
    completed: 'bg-green-100 text-green-700',
    pending: 'bg-amber-100 text-amber-700',
    failed: 'bg-red-100 text-red-700',
  }[status] || 'bg-gray-100 text-gray-700';
  const label = {
    completed: 'Completed',
    pending: 'Pending',
    failed: 'Failed',
  }[status] || status;
  return (
    <span className={`px-2 py-1 rounded-full text-xs ${classes}`}>
      {label}
    </span>
  );
}

/** Return the last-4 masked form of an account number. */
export function maskAccountNumber(num) {
  if (!num) return '****';
  return `••••${num.slice(-4)}`;
}

/** True if a txn moves money out of the wallet. */
export function isDebit(type) {
  return ['withdrawal', 'transfer', 'escrow_hold', 'marketplace_purchase', 'commission_reversal', 'p2p_sent', 'chargeback', 'fee'].includes(type);
}
